export default __webpack_public_path__ + "static/media/score.7e42603c.png";